import { useMemo } from 'react';
import { uniqBy } from 'lodash-es';
import { LogisticsProjectionType } from '@/api/apis/route';
import { useDriveTripsByIdsQuery } from '@/queries/drive-service';
import { DriverInfo, getNopConnectDrivers, getTmdxDriveDrivers } from '@/utils/route';

export const useLogisticsDrivers = (logisticsProjection?: LogisticsProjectionType) => {
  const { groundTripIds } = logisticsProjection || {};
  const tripResults = useDriveTripsByIdsQuery(groundTripIds ?? []);
  const isLoading = tripResults.some((r) => r.isLoading);

  const drivers = useMemo((): DriverInfo[] => {
    if (!logisticsProjection) return [];

    const driveTripsData = tripResults.map((r) => r.data).filter(Boolean);
    const totalLegsData = logisticsProjection?.routes.flatMap((r) => r.legs) ?? [];
    const allDrivers = [...getNopConnectDrivers(totalLegsData), ...getTmdxDriveDrivers(totalLegsData, driveTripsData)];

    return uniqBy(allDrivers, 'driver');
  }, [logisticsProjection, tripResults]);

  return {
    isLoading,
    drivers: isLoading ? [] : drivers,
  };
};
